// extracted by mini-css-extract-plugin
export default {"card":"intrests_card__IXwL5","icon":"intrests_icon__IW7e1","text":"intrests_text__jlqP1","cont":"intrests_cont__gE3Tx","cards":"intrests_cards__vYVN+"};